import { render, staticRenderFns } from "./Th.vue?vue&type=template&id=3ada5cbe"
import script from "./Th.vue?vue&type=script&lang=js"
export * from "./Th.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports